import _ from "lodash";
import { useEffect } from "react";
import { convertArrayToSelectList } from "../../helper";
import QalboxMultiSelectDropdown from "../../media/helperComponents/qalboxMultiSelect";
import { genresSearch } from "../../../../hooks";
import { ScaleLoader } from "react-spinners";
import LoadingOverlay from "react-loading-overlay";

export const QalboxGenresDropdown = ({genres, handleMultiSelect}) => {
  const [responseGenreData, setGenreOperationData] = genresSearch();

  const requestGenreData = () => {
    setGenreOperationData({
      searchConfig: {
        language_code: 'en',
        active: true,
      },
    });
  };

  useEffect(() => {
    requestGenreData();
  }, []);

  return (
    <LoadingOverlay
      active={_.get(responseGenreData, "isLoading", false)}
      spinner={<ScaleLoader />}
      text="Loading...."
    >
      <div className="form-group">
        <label>Genres</label>
        <QalboxMultiSelectDropdown
          name={"genres"}
          onChange={handleMultiSelect}
          selectedOptions={convertArrayToSelectList(genres)}
          options={convertArrayToSelectList(
            _.get(responseGenreData, "data", []).map((x) => x.name)
          )}
        />
      </div>
    </LoadingOverlay>
  );
};